module.exports = __webpack_public_path__ + "img/asus-ux431.36961055.jpg";